import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=4304a2ed&scoped=true"
import script from "./SearchButton.vue?vue&type=script&lang=js"
export * from "./SearchButton.vue?vue&type=script&lang=js"
import style0 from "./SearchButton.vue?vue&type=style&index=0&id=4304a2ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304a2ed",
  null
  
)

export default component.exports